import { AxiosError } from 'axios'

export function isAxiosError(e: Error | AxiosError): e is AxiosError {
  return (e as AxiosError).isAxiosError === true
}
